import Notifications from './Notifications.vue';

const NotificationStore = {
  state: [], // here the notifications will be added
  settings: {
    overlap: false,
    verticalAlign: 'top',
    horizontalAlign: 'right',
    type: 'info',
    timeout: 5000,
    closeOnClick: true,
    showClose: true,
  },
  setOptions(options) {
    this.settings = Object.assign(this.settings, options);
  },
  removeNotification(timestamp) {
    const indexToDelete = this.state.findIndex((n) => n.timestamp === timestamp);
    if (indexToDelete !== -1) {
      this.state.splice(indexToDelete, 1);
    }
  },
  addNotification(notification) {
    if (typeof notification === 'string' || notification instanceof String) {
      notification = { message: notification };
    }
    notification.timestamp = new Date();
    notification.timestamp.setMilliseconds(notification.timestamp.getMilliseconds() + this.state.length);
    notification = Object.assign({}, this.settings, notification);
    this.state.push(notification);
  },
  notify(notification) {
    if (Array.isArray(notification)) {
      notification.forEach((notificationInstance) => {
        this.addNotification(notificationInstance);
      });
    } else {
      this.addNotification(notification);
    }
  },
};

const NotificationsPlugin = {
  install(Vue, options) {
    let app = new Vue({
      data: {
        notificationStore: NotificationStore,
      },

      methods: {
        notify(notification) {
          this.notificationStore.notify(notification);
        },

        showNotification(message = '', title = '', options = {}) {
          const notification = Object.assign(
            {
              title: title,
              message: message,
              timeout: 5000,
            },
            options
          );
          this.notify(notification);
        },

        success(message, title = 'Exito!', options = {}) {
          this.showNotification(
            message,
            title,
            Object.assign(options, {
              icon: 'fas fa-check-circle',
              type: 'success',
            })
          );
        },

        error(message, title = 'Error!', options = {}) {
          this.showNotification(
            message,
            title,
            Object.assign(options, {
              icon: 'fas fa-times-circle',
              type: 'danger',
            })
          );
        },

        warning(message, title = 'Fallo!', options = {}) {
          this.showNotification(
            message,
            title,
            Object.assign(options, {
              icon: 'fas fa-exclamation-circle',
              type: 'warning',
            })
          );
        },

        info(message, title = 'Importante!', options = {}) {
          this.showNotification(
            message,
            title,
            Object.assign(options, {
              icon: 'fas fa-info-circle',
              type: 'info',
            })
          );
        },
      },
    });
    Vue.prototype.$notify = app.notify;
    Vue.prototype.$success = app.success;
    Vue.prototype.$error = app.error;
    Vue.prototype.$warning = app.warning;
    Vue.prototype.$info = app.info;
    Vue.prototype.$notifications = app.notificationStore;
    Vue.component('Notifications', Notifications);
    if (options) {
      NotificationStore.setOptions(options);
    }
  },
};

export default NotificationsPlugin;
